module.exports = __webpack_public_path__ + "static/img/jsfw.2e0f66e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jsfw.png
// module id = Y49D
// module chunks = 0